import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './NotesButtonAndDropdown';
import { ChatStoreSlice } from '../../../Chat/redux/types';
import { getChatHasMessage } from '../../../Notes/redux/unreadChats/selectors';

export type StateProps = Pick<Props, 'hasNewMsg'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  ChatStoreSlice
> = state => ({
  hasNewMsg: getChatHasMessage(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
